package com.tovtalk.ui.screen.profile

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.tovtalk.domain.entity.ContactPhoneItem
import com.tovtalk.domain.entity.DomainResult
import com.tovtalk.domain.repository.AppRepository
import com.tovtalk.di.koinInject
import com.tovtalk.ui.platform.rememberAddContactToDevice
import com.tovtalk.ui.theme.TovTalkTheme
import com.tovtalk.utils.strings.StringProvider

@Composable
fun EditProfileContactsDialog(
    onDismiss: () -> Unit,
    appRepository: AppRepository = koinInject(),
) {
    var contacts by remember { mutableStateOf<List<ContactPhoneItem>>(emptyList()) }
    var loading by remember { mutableStateOf(true) }
    val addToDevice = rememberAddContactToDevice()

    LaunchedEffect(Unit) {
        loading = true
        when (val result = appRepository.getContactPhones()) {
            is DomainResult.Success -> contacts = result.data
            else -> contacts = emptyList()
        }
        loading = false
    }

    AlertDialog(
        onDismissRequest = onDismiss,
        title = { Text(StringProvider.get("edit_profile_contacts_dialog_title")) },
        text = {
            if (loading) {
                CircularProgressIndicator(modifier = Modifier.fillMaxWidth(), color = TovTalkTheme.colors.brand)
            } else {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .verticalScroll(rememberScrollState()),
                    verticalArrangement = Arrangement.spacedBy(TovTalkTheme.spacing.sm),
                ) {
                    if (contacts.isEmpty()) {
                        Text(
                            StringProvider.get("edit_profile_contacts_empty"),
                            style = TovTalkTheme.typography.bodyMedium,
                            color = TovTalkTheme.colors.textSecondary,
                        )
                    } else {
                        contacts.forEach { item ->
                            Column(modifier = Modifier.fillMaxWidth()) {
                                Text(
                                    text = "${item.name}: ${item.phone}",
                                    style = TovTalkTheme.typography.bodyMedium,
                                    color = TovTalkTheme.colors.textPrimary,
                                )
                                OutlinedButton(
                                    onClick = { addToDevice(item.name, item.phone) },
                                    modifier = Modifier.padding(top = TovTalkTheme.spacing.xs),
                                ) {
                                    Text(StringProvider.get("edit_profile_contacts_add_to_device"))
                                }
                                HorizontalDivider(
                                    modifier = Modifier.padding(vertical = TovTalkTheme.spacing.xs),
                                    color = TovTalkTheme.colors.border,
                                )
                            }
                        }
                    }
                }
            }
        },
        confirmButton = {
            OutlinedButton(onClick = onDismiss) {
                Text(StringProvider.get("common_close"))
            }
        },
    )
}
